import { Box, Flex, Heading, Text } from '@chakra-ui/react';
import {
  AccordionItemContent,
  AccordionItemTrigger,
  AppLink,
  Badge,
  Image,
  pxToRem,
} from '@cyberkongz/ui';

import { CARDS_METAVERSE } from './content/cards';
import {
  ActiveCardSidebar,
  CardItemWrapper,
  CardsSectionWrapper,
  IntroSectionWrapper,
  introTextStyles,
  ListOfPartnerships,
  useCardsSection,
} from './Shared';

function IntroSection() {
  return (
    <IntroSectionWrapper>
      <Heading mb={2}>to the </Heading>
      <Heading variant="displaySecondary">METAVERSE and beyond</Heading>
      <Text css={{ ...introTextStyles, maxW: '35em' }}>
        To prepare for the Kongz arrival as the leading social avatars in the metaverse, we have
        invested in a variety of assets across various metaverses. This will allow us to create
        custom CyberKongz experiences and distribute asset rewards to holders via Play & Kollect.
      </Text>
    </IntroSectionWrapper>
  );
}

function CardsSection() {
  const { activeItem, handleChange } = useCardsSection();
  const activeCardSidebar = activeItem ? (
    <ActiveCardSidebar {...CARDS_METAVERSE[parseInt(activeItem)]} basePath="metaverse" />
  ) : null;

  return (
    <CardsSectionWrapper
      {...{
        activeItem,
        handleChange,
        activeCardSidebar,
        sxBackground: {
          backgroundImage: 'url(/static/blueprint/metaverse/cards_bg.jpg)',
        },
      }}
    >
      {CARDS_METAVERSE.map(({ title, image, href, description }, i) => (
        <CardItemWrapper key={i} value={i}>
          <AccordionItemTrigger>
            <Flex css={{ justifyContent: 'space-between', alignItems: 'center', flex: 1 }}>
              <Badge badgeColor="tertiary" withDot>
                In progress
              </Badge>
              <Box css={{ display: ['none', 'block'] }}>
                <Image
                  src={image}
                  alt={title}
                  css={{ maxHeight: pxToRem(85), maxWidth: pxToRem(150) }}
                />
              </Box>
            </Flex>
          </AccordionItemTrigger>
          <Heading size="2xs" css={{ mt: [4, 12], color: 'text' }}>
            Presence in <AppLink href={href}>{title}</AppLink>
          </Heading>
          <AccordionItemContent>
            <Box color="textSecondary">{description}</Box>
            <Box display={['block', 'none']}>{activeCardSidebar}</Box>
          </AccordionItemContent>
        </CardItemWrapper>
      ))}
    </CardsSectionWrapper>
  );
}

export function MetaverseTab() {
  return (
    <>
      <IntroSection />
      <CardsSection />
      <ListOfPartnerships />
    </>
  );
}
